module.exports = {
	"testing": "false",
	"id": "ca-app-pub-2630573146206691/4453175568",
	"inter": "ca-app-pub-2630573146206691/4453175568"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/admob.json
// module id = 681
// module chunks = 0